import { Reveal } from "./Reveal";

export const Intro = () => (
  <section
    data-testid="intro-section"
    className="px-6 md:px-12 py-28 md:py-40 lg:py-48"
  >
    <div className="max-w-6xl">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium mb-10">
          The Journey
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.15] tracking-tight text-soil max-w-5xl">
          Where movement becomes a{" "}
          <span className="italic text-amethyst">gateway to healing</span>,
          where somatic movement and body awareness soften you into{" "}
          <span className="italic text-amethyst">safety and stability</span>{" "}
          within the body.
        </p>
      </Reveal>
      <div className="mt-16 md:mt-24 grid md:grid-cols-12 gap-10">
        <Reveal delay={0.15} className="md:col-span-5 md:col-start-2">
          <p className="text-base md:text-lg text-clay leading-relaxed">
            Embodied Awakening is a sacred container supporting your spiritual
            process through nervous system regulation, body awareness,
            identifying the root of fear, and reconnecting with your true
            sense of self.
          </p>
        </Reveal>
        <Reveal delay={0.25} className="md:col-span-5 md:col-start-8">
          <p className="text-base md:text-lg text-clay leading-relaxed">
            Through somatic movement, kundalini yoga, meditation and
            body-based practices, you will learn practical tools that support
            long-term integration, stability, safety, and consistency. An
            invitation to return home to the body.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
